module.exports = __webpack_public_path__ + "img/ercode_gd.30823b36.png";